import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { getCashRegister } from './services';

export const useGetCashRegister = () => {
  const { uuid } = useParams();
  const query = useQuery({
    queryKey: ['cashRegister', uuid],
    queryFn: () => getCashRegister(uuid),
  });

  return { ...query, data: query.data?.data };
};
